import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ZohoObjectDataset } from 'app/model/dataset/zoho.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'ZohoSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(ZohoObjectDataset) }
})
export class ZohoCopySource extends TabularCopySource {
}
